import { PIN_VIEW } from '../config/pin';
import type { IntoxicationLevel } from '../config/intoxication';
import { clamp } from '../utils/math';

export function pinMotion(time: number, dose: IntoxicationLevel) {
  const strength = clamp(dose.alcoholPromille / PIN_VIEW.alcoholScale, 0, 1) * PIN_VIEW.alcoholGain
    + clamp(dose.drugsPercent / PIN_VIEW.drugScale, 0, 1);
  return {
    x: Math.sin(time * 1.7) * PIN_VIEW.maxX * strength,
    y: Math.sin(time * 2.3 + 0.8) * PIN_VIEW.maxY * strength,
    rotation: Math.sin(time * 1.3 + 1.4) * PIN_VIEW.maxRotation * strength,
  };
}
